import { render } from "./ScorerConfig.vue?vue&type=template&id=8ff5a1ce"
import script from "./ScorerConfig.vue?vue&type=script&lang=js"
export * from "./ScorerConfig.vue?vue&type=script&lang=js"

import exportComponent from "/home/james/WebstormProjects/pvpconfigui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__